import axios, { type AxiosInstance, type InternalAxiosRequestConfig } from "axios";

/**
 * Axios instance with interceptors for authentication
 */
const apiClient: AxiosInstance = axios.create({
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor to add auth token
apiClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = localStorage.getItem("gcpToken");
    if (token && config.headers) {
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle common errors (401, 403, 500, etc.)
    // Don't redirect on login/register endpoints to avoid immediate logout
    const url = error.config?.url || "";
    const isAuthEndpoint = url.includes("user-login") || url.includes("user-createMerchantUser");
    const isPublicTrackOrder = url.includes("order-trackOrder");
    const isPublicTrackReturn = url.includes("order-trackReturnOrder");

    if (
      error.response?.status === 401 &&
      !isAuthEndpoint &&
      !isPublicTrackOrder &&
      !isPublicTrackReturn
    ) {
      // Unauthorized - clear auth and redirect to login
      // Only redirect if not already on login page
      if (window.location.pathname !== "/login") {
        localStorage.removeItem("gcpToken");
        localStorage.removeItem("UserData");
        localStorage.removeItem("impersonating");
        // Flag a revoked/expired session so the login screen can explain why the user landed
        // there. The hard reload below would otherwise kill any toast shown at this point.
        const expired = error.response?.data?.data?.code === "TOKEN_EXPIRED";
        window.location.href = expired ? "/login?expired=1" : "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
